/**
 * A mensagem que o backend escreveu, e não "non-2xx status code".
 *
 * `supabase.functions.invoke` transforma qualquer resposta 4xx/5xx num
 * FunctionsHttpError cuja `message` é sempre a mesma frase genérica — o corpo,
 * onde está o motivo de verdade, fica guardado em `context` (a Response) e
 * ninguém lia. Foi assim que a recusa da fatura em imagem chegou na tela como
 * "Erro na análise: Edge Function returned a non-2xx status code", sem dizer ao
 * consultor o que fazer.
 */
export async function mensagemDaFuncao(erro: unknown, padrao = 'Falha ao processar'): Promise<string> {
  const contexto = (erro as { context?: unknown })?.context;
  const resposta = contexto instanceof Response ? contexto : undefined;
  if (resposta) {
    try {
      const corpo = await resposta.clone().json();
      const texto = corpo?.error || corpo?.message;
      if (typeof texto === 'string' && texto.trim()) return texto;
    } catch {
      /* corpo sem JSON: cai na mensagem original */
    }
  }
  const original = erro instanceof Error ? erro.message : '';
  return original && !/non-2xx status code/i.test(original) ? original : padrao;
}
